import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-blue-50 flex items-center justify-center p-8">
      <div className="max-w-4xl w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
            <i className="ri-cube-3d-fill text-5xl text-white"></i>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-4">XR CMS</h1>
          <p className="text-xl text-gray-600 mb-2">適蔵XR Webシステム</p>
          <p className="text-lg text-gray-500">3D素材管理システム</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-gray-200/80">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">システム機能</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl">
              <div className="w-14 h-14 bg-blue-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-box-3-fill text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">材料データ</h3>
              <p className="text-sm text-gray-600">3D素材パケットとテクスチャの管理</p>
            </div>

            <div className="p-6 bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-xl">
              <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-fill text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">施工データ</h3>
              <p className="text-sm text-gray-600">施工現場のXRデータとプロジェクト情報</p>
            </div>

            <div className="p-6 bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-xl">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-store-2-fill text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">店舗データ</h3>
              <p className="text-sm text-gray-600">店舗情報と関連する3Dデータの管理</p>
            </div>
          </div>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          className="px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-xl font-bold text-lg hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
        >
          ダッシュボードを開く
          <i className="ri-arrow-right-line ml-2"></i>
        </button>

        <p className="text-sm text-gray-500 mt-8">
          Copyright 2025 by SOLIZE Corporation All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
